import { c as _c } from "react/compiler-runtime";
import { css, cx } from '@repo/pandacss/css';
import { type MaskIconVariantProps, maskIcon } from '@repo/pandacss/recipes';
import type { SystemStyleObject } from '@repo/pandacss/types';
import type { ComponentPropsWithRef } from 'react';
type MaskIconProps = MaskIconVariantProps & ComponentPropsWithRef<'span'> & {
  glyph: MaskIconVariantProps['glyph'];
  css?: SystemStyleObject;
  className?: string;
};
export const MaskIcon = t0 => {
  const $ = _c(15);
  let className;
  let cssProp;
  let glyph;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      glyph,
      size,
      className,
      css: cssProp,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = cssProp;
    $[3] = glyph;
    $[4] = props;
    $[5] = size;
  } else {
    className = $[1];
    cssProp = $[2];
    glyph = $[3];
    props = $[4];
    size = $[5];
  }
  let t1;
  if ($[6] !== className || $[7] !== cssProp || $[8] !== glyph || $[9] !== size) {
    t1 = cx(maskIcon({
      glyph,
      size
    }), css(cssProp), className);
    $[6] = className;
    $[7] = cssProp;
    $[8] = glyph;
    $[9] = size;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  let t2;
  if ($[11] !== glyph || $[12] !== props || $[13] !== t1) {
    t2 = <span data-icon={glyph} aria-hidden="true" className={t1} {...props} />;
    $[11] = glyph;
    $[12] = props;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  return t2;
};